// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eRoY","col":"styles_col__jHEtX"};